import React from 'react';

import CommonImages from './index';
const AnimatedLogo = CommonImages.ECAL_LOADING;

/**
 * A wrapper for SVGs that use internal <script> tags and onload="init(evt)"
 * specifically for Vite + svgr projects.
 */

const AnimatedEcalLogo = ({ ...props }) => {
    return (
        <iframe 
            src={AnimatedLogo} 
            title="loading"
            scrolling="no"
            frameBorder="0"
            sandbox="allow-scripts allow-same-origin"
            {...props}
        />
    );
};

export default AnimatedEcalLogo;